import { render } from "./searchResults.vue?vue&type=template&id=5f1bba1a"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\cr\\SitefinityWebApp\\FrontEndResources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__